import React from 'react';

import { ISectionWithPagePointersFields } from '../../../types/contentful';

import { PagePointer } from '../PagePointer';
import { ScrollReveal } from '../ScrollReveal';

export function SectionWithPagePointers({
  heading,
  pagePointers
}: ISectionWithPagePointersFields) {
  return (
    <ScrollReveal>
      <div
        className="block-container mb-16 mt-16"
        data-blockid="sectionWithPagePointers"
        data-testid="section-with-page-pointers"
      >
        <div className="w-full px-3 tablet:px-12">
          <div className="flex-[1_0_100%]">
            <div className="-m-2 flex flex-wrap justify-center tablet:-m-3 desktop:-m-4">
              <div className="flex w-10/12 shrink-0 grow-0 flex-col p-2 tablet:w-8/12 tablet:p-3 desktop:p-4">
                {heading && (
                  <h2 className="mb-2 mt-2 text-center text-[28px] font-medium leading-8 tablet:mb-4 tablet:mt-4 tablet:text-[32px] tablet:leading-9 desktop:mb-8 desktop:mt-8 desktop:text-[42px] desktop:leading-12">
                    {heading}
                  </h2>
                )}
                {pagePointers &&
                  pagePointers.map(({ sys, fields }) => {
                    return fields && <PagePointer {...fields} key={sys?.id} />;
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ScrollReveal>
  );
}
